export default {
  errors: null,
  currencies: [],
  loading: false,
  count: 0,
  totalCount: 0,
  loaded: false,
};
